import React, { useEffect, useState } from 'react';
interface PopData {
  name: string;
  location: string;
  action: string;
  time: string;
}
const popData: PopData[] = [{
  name: 'María G.',
  location: 'Madrid',
  action: 'acaba de adquirir el Protocolo B.E.B.E. 365',
  time: 'hace 2 minutos'
}, {
  name: 'Carlos M.',
  location: 'México DF',
  action: 'agregó al carrito el bundle completo',
  time: 'hace 5 minutos'
}, {
  name: 'Valentina R.',
  location: 'Buenos Aires',
  action: 'acaba de comprar Noches de Oro',
  time: 'hace 3 minutos'
}, {
  name: 'Sofía L.',
  location: 'Barcelona',
  action: 'acaba de adquirir el Protocolo B.E.B.E. 365',
  time: 'hace 1 minuto'
}, {
  name: 'Andrés P.',
  location: 'Bogotá',
  action: 'agregó al carrito el bundle completo',
  time: 'hace 7 minutos'
}, {
  name: 'Daniela C.',
  location: 'Miami',
  action: 'acaba de comprar el protocolo completo',
  time: 'hace 4 minutos'
}, {
  name: 'Roberto F.',
  location: 'Lima',
  action: 'acaba de adquirir el Protocolo B.E.B.E. 365',
  time: 'hace 6 minutos'
}, {
  name: 'Isabella T.',
  location: 'Santiago',
  action: 'agregó al carrito Pequeño Genio',
  time: 'hace 2 minutos'
}];
export function PopNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPop, setCurrentPop] = useState<PopData>(popData[0]);
  const [popIndex, setPopIndex] = useState(0);
  useEffect(() => {
    const showPop = () => {
      const data = popData[popIndex % popData.length];
      setCurrentPop(data);
      setIsVisible(true);
      setPopIndex(prev => prev + 1);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // First pop after 20 seconds
    const firstTimeout = setTimeout(() => {
      showPop();
      // Then every 20-25 seconds
      const interval = setInterval(() => {
        const delay = Math.floor(Math.random() * 5000) + 20000;
        setTimeout(showPop, delay);
      }, 25000);
      return () => clearInterval(interval);
    }, 20000);
    return () => clearTimeout(firstTimeout);
  }, [popIndex]);
  if (!isVisible) return null;
  return <div className="fixed bottom-5 left-5 z-[9999] bg-white rounded-xl p-3.5 shadow-2xl max-w-[300px] w-[90%] border-l-4 border-[#B76E79] animate-slide-in font-sans" data-id="element-205">
      <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2.5 text-xl text-[#6B4C3B] bg-transparent border-none cursor-pointer" data-id="element-206">
        ×
      </button>
      <span className="text-2xl mr-2.5 float-left" data-id="element-207">🛒</span>
      <div className="text-[13px] text-[#3D2B1F] leading-relaxed" data-id="element-208">
        <strong className="text-[#B76E79] block text-sm" data-id="element-209">
          {currentPop.name} de {currentPop.location}
        </strong>
        <span data-id="element-210">{currentPop.action}</span>
        <div className="text-[11px] text-gray-400 mt-1" data-id="element-211">{currentPop.time}</div>
      </div>
    </div>;
}